export default function About() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-4xl font-bold text-[#003366] mb-6 md:mb-8 text-center leading-tight">
          ESTÁ DEIXANDO DINHEIRO NA MESA?
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 p-5 md:p-8 rounded-xl shadow-lg border border-gray-100 mb-6 md:mb-8">
            <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-6">
              O Mercado Livre de Energia já está disponível para sua empresa, mas enquanto você
              ainda não migrou, sua operação continua sangrando recursos que poderiam estar no seu
              caixa.
            </p>
            <p className="text-base md:text-lg text-gray-700">
              Empresas de todos os tamanhos estão cortando drasticamente seus custos operacionais
              enquanto seus concorrentes continuam pagando caro pela energia.
            </p>
          </div>
          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="inline-block bg-[#FFD700] hover:bg-yellow-400 text-[#003366] font-bold py-3 md:py-4 px-5 md:px-8 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
            >
              QUERO ECONOMIZAR NA CONTA DE ENERGIA
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
